<template>
  <component :is="layoutComponent">
    <router-view />
  </component>
  <sm-notify-bar></sm-notify-bar>
</template>


<script lang="ts" setup>
// Vue moduls
import { computed, onMounted, onUnmounted } from 'vue';

// Composables
import { useRoute } from 'vue-router';
import { useReminders } from '~/composables/useReminders';

// Components
import SmNotifyBar from '@core/components/common/notify/SmNotifyBar.vue';

// Utils TODO: Исправить название функции
import { setCSSStyles } from '@core/utils/setCSSStyles';

const route = useRoute();
const layoutComponent = computed(() => route.meta.layoutComponent || null);

const { actualizeReminders, startTimer, stopTimer } = useReminders();

const init = async () => {
  const userAgent = navigator.userAgent;
  if (userAgent.includes("Firefox")) {
    document.body.classList.add("firefox");
  }
  setCSSStyles();
}

// Hooks
init();

onMounted(() => {
  actualizeReminders();
  startTimer();
});

onUnmounted(() => {
  stopTimer();
});
</script>